export default "__VITE_ASSET__21360798__"